const map = {
	"./GfT0001.1.tif": 14564,
	"./GfT0002.1.tif": 82327,
	"./GfT0003.1.tif": 90770,
	"./GfT0004.1.tif": 33525,
	"./GfT0005.1.tif": 79760,
	"./GfT0007.1.tif": 5358,
	"./GfT0008.1.tif": 40049,
	"./GfT0010.1.tif": 96062,
	"./GfT0011.1.tif": 48835,
	"./GfT0012.1.tif": 31104,
	"./GfT0013.1.tif": 24805,
	"./GfT0014.1.tif": 24162,
	"./GfT0015.1.tif": 57319,
	"./GfT0016.1.tif": 64852,
	"./GfT0020.1.tif": 77151,
	"./GfT0021.1.tif": 54554,
	"./GfT0022.1.tif": 83489,
	"./GfT0024.1.tif": 91419,
	"./GfT0025.1.tif": 45238,
	"./GfT0026.1.tif": 23869,
	"./GfT0027.1.tif": 67672,
	"./GfT0029.1.tif": 27170,
	"./GfT0030.1.tif": 56476,
	"./GfT0031.1.tif": 50865,
	"./GfT0033.1.tif": 20367,
	"./GfT0034.1.tif": 85256,
	"./GfT0034.2.tif": 98439,
	"./GfT0035.1.tif": 4525,
	"./GfT0037.1.tif": 82731,
	"./GfT0037.2.tif": 21356,
	"./GfT0038.1.tif": 9028,
	"./GfT0040.1.tif": 91741,
	"./GfT0041.1.tif": 38936,
	"./GfT0042.1.tif": 84027,
	"./GfT0043.1.tif": 32982,
	"./GfT0044.1.tif": 4961,
	"./GfT0045.1.tif": 76300,
	"./GfT0046.1.tif": 55295,
	"./GfT0047.1.tif": 92378,
	"./GfT0048.1.tif": 58917,
	"./GfT0049.1.tif": 95840,
	"./GfT0050.1.tif": 52882,
	"./GfT0051.1.tif": 50500,
	"./GfT0052.1.tif": 39780,
	"./GfT0053.1.tif": 3161,
	"./GfT0055.1.tif": 28051,
	"./GfT0056.1.tif": 21104,
	"./GfT0057.1.tif": 3381,
	"./GfT0058.1.tif": 83018,
	"./GfT0059.1.tif": 10607,
	"./GfT0060.1.tif": 62979,
	"./GfT0060.2.tif": 45412,
	"./GfT0061.1.tif": 77086,
	"./GfT0062.1.tif": 66373,
	"./GfT0063.1.tif": 6944,
	"./GfT0064.1.tif": 54055,
	"./GfT0065.1.tif": 17794,
	"./GfT0066.1.tif": 37673,
	"./GfT0067.1.tif": 92788,
	"./GfT0068.1.tif": 8219,
	"./GfT0069.1.tif": 62038,
	"./GfT0070.1.tif": 11824,
	"./GfT0071.1.tif": 65589,
	"./GfT0072.1.tif": 37422,
	"./GfT0073.1.tif": 14899,
	"./GfT0073.2.tif": 91444,
	"./GfT0074.1.tif": 30276,
	"./GfT0075.1.tif": 68473,
	"./GfT0079.1.tif": 37677,
	"./GfT0079.2.tif": 43450,
	"./GfT0079.3.tif": 42011,
	"./GfT0079.4.tif": 44800,
	"./GfT0080.1.tif": 86689,
	"./GfT0081.1.tif": 27532,
	"./GfT0082.1.tif": 29823,
	"./GfT0083.1.tif": 282,
	"./GfT0084.1.tif": 221,
	"./GfT0085.1.tif": 41144,
	"./GfT0086.1.tif": 44091,
	"./GfT0087.1.tif": 14262,
	"./GfT0088.1.tif": 89897,
	"./GfT0089.1.tif": 28660,
	"./GfT0090.1.tif": 34438,
	"./GfT0091.1.tif": 59083,
	"./GfT0092.1.tif": 1256,
	"./GfT0095.1.tif": 20015,
	"./GfT0097.1.tif": 24337,
	"./GfT0098.1.tif": 73294,
	"./GfT0099.1.tif": 67123,
	"./GfT0100.1.tif": 44236,
	"./GfT0101.1.tif": 79841,
	"./GfT0103.1.tif": 99532,
	"./GfT0104.1.tif": 80024,
	"./GfT0106.1.tif": 15190,
	"./GfT0108.1.tif": 97524,
	"./GfT0110.1.tif": 84751,
	"./GfT0111.1.tif": 23210,
	"./GfT0112.1.tif": 72721,
	"./GfT0113.1.tif": 78332,
	"./GfT0114.1.tif": 7467,
	"./GfT0114.2.tif": 69388,
	"./GfT0115.1.tif": 82822,
	"./GfT0116.1.tif": 21933,
	"./GfT0117.1.tif": 49640,
	"./GfT0118.1.tif": 14999,
	"./GfT0119.1.tif": 23442,
	"./GfT0120.1.tif": 1742,
	"./GfT0121.1.tif": 11347,
	"./GfT0124.1.tif": 52530,
	"./GfT0124.2.tif": 12389,
	"./GfT0125.1.tif": 11415,
	"./GfT0126.1.tif": 39428,
	"./GfT0127.1.tif": 86457,
	"./GfT0128.1.tif": 95014,
	"./GfT0129.1.tif": 24843,
	"./GfT0130.1.tif": 62985,
	"./GfT0131.1.tif": 82260,
	"./GfT0132.1.tif": 8903,
	"./GfT0133.1.tif": 18274,
	"./GfT0135.1.tif": 79136,
	"./GfT0136.1.tif": 66243,
	"./GfT0138.1.tif": 88257,
	"./GfT0139.1.tif": 75948,
	"./GfT0140.1.tif": 11200,
	"./GfT0141.1.tif": 74277,
	"./GfT0142.1.tif": 33630,
	"./GfT0143.1.tif": 98307,
	"./GfT0144.1.tif": 14324,
	"./GfT0145.1.tif": 95049,
	"./GfT0146.1.tif": 50338,
	"./GfT0147.1.tif": 40967,
	"./GfT0148.1.tif": 70648,
	"./GfT0149.1.tif": 7101,
	"./GfT0150.1.tif": 36755,
	"./GfT0154.1.tif": 19895,
	"./GfT0154.2.tif": 76504,
	"./GfT0154.3.tif": 6569,
	"./GfT0155.1.tif": 16946,
	"./GfT0156.1.tif": 85881,
	"./GfT0157.1.tif": 40740,
	"./GfT0158.1.tif": 98091,
	"./GfT0159.1.tif": 73446,
	"./GfT0160.1.tif": 42530,
	"./GfT0161.1.tif": 71463,
	"./GfT0162.1.tif": 44372,
	"./GfT0163.1.tif": 78761,
	"./GfT0165.1.tif": 84835,
	"./GfT0166.1.tif": 1056,
	"./GfT0167.1.tif": 14405,
	"./GfT0168.1.tif": 86266,
	"./GfT0169.1.tif": 92511,
	"./GfT0170.1.tif": 67341,
	"./GfT0171.1.tif": 8680,
	"./GfT0173.1.tif": 63302,
	"./GfT0174.1.tif": 22129,
	"./GfT0175.1.tif": 84988,
	"./GfT0176.1.tif": 35343,
	"./GfT0177.1.tif": 4874,
	"./GfT0178.1.tif": 25237,
	"./GfT0179.1.tif": 19664,
	"./GfT0180.1.tif": 44020,
	"./GfT0181.1.tif": 5257,
	"./GfT0185.1.tif": 17605,
	"./GfT0186.1.tif": 44670,
	"./GfT0187.1.tif": 30563,
	"./GfT0189.1.tif": 2049,
	"./GfT0190.1.tif": 79351,
	"./GfT0191.1.tif": 20466,
	"./GfT0192.1.tif": 54393,
	"./GfT0194.1.tif": 95635,
	"./GfT0195.1.tif": 69678,
	"./GfT0195.2.tif": 79729,
	"./GfT0195.3.tif": 26944,
	"./GfT0196.1.tif": 70965,
	"./GfT0196.2.tif": 27298,
	"./GfT0196.3.tif": 8163,
	"./GfT0197.1.tif": 88688,
	"./GfT0200.1.tif": 92647,
	"./GfT0201.1.tif": 40034,
	"./GfT0202.1.tif": 76265,
	"./GfT0208.1.tif": 32543,
	"./GfT0208.2.tif": 37856,
	"./GfT0208.3.tif": 94193,
	"./GfT0209.1.tif": 3002,
	"./GfT0209.2.tif": 68973,
	"./GfT0209.3.tif": 78684,
	"./GfT0212.1.tif": 61426,
	"./GfT0212.2.tif": 16389,
	"./GfT0216.1.tif": 76014,
	"./GfT0216.2.tif": 68657,
	"./GfT0216.3.tif": 44608,
	"./GfT0217.1.tif": 53491,
	"./GfT0218.1.tif": 16316,
	"./GfT0219.1.tif": 10705,
	"./GfT0220.1.tif": 43553,
	"./GfT0222.1.tif": 93887,
	"./GfT0223.1.tif": 30970,
	"./GfT0224.1.tif": 30333,
	"./GfT0225.1.tif": 77528,
	"./GfT0226.1.tif": 22619,
	"./GfT0227.1.tif": 55222,
	"./GfT0228.1.tif": 1929,
	"./GfT0229.1.tif": 37556,
	"./GfT0231.1.tif": 80139,
	"./GfT0233.1.tif": 64845,
	"./GfT0234.1.tif": 21610,
	"./GfT0235.1.tif": 32847,
	"./GfT0236.1.tif": 6172,
	"./GfT0237.1.tif": 92785,
	"./GfT0238.1.tif": 40686,
	"./GfT0239.1.tif": 66643,
	"./GfT0240.1.tif": 37035,
	"./GfT0241.1.tif": 12390,
	"./GfT0242.1.tif": 75181,
	"./GfT0243.1.tif": 55912,
	"./GfT0244.1.tif": 91023,
	"./GfT0246.1.tif": 21521,
	"./GfT0247.1.tif": 27132,
	"./GfT0248.1.tif": 75699,
	"./GfT0249.1.tif": 44302,
	"./GfT0250.1.tif": 9592,
	"./GfT0254.1.tif": 46956,
	"./GfT0254.2.tif": 85035,
	"./GfT0254.3.tif": 9738,
	"./GfT0254.4.tif": 98081,
	"./GfT0255.1.tif": 75617,
	"./GfT0256.1.tif": 46682,
	"./GfT0258.1.tif": 50144,
	"./GfT0258.2.tif": 44831,
	"./GfT0259.1.tif": 13221,
	"./GfT0260.1.tif": 79109,
	"./GfT0261.1.tif": 85408,
	"./GfT0262.1.tif": 19491,
	"./GfT0263.1.tif": 50366,
	"./GfT0264.1.tif": 92553,
	"./GfT0265.1.tif": 35508,
	"./GfT0266.1.tif": 11623,
	"./GfT0267.1.tif": 78466,
	"./GfT0268.1.tif": 47133,
	"./GfT0269.1.tif": 18008,
	"./GfT0273.1.tif": 37793,
	"./GfT0273.2.tif": 13470,
	"./GfT0273.3.tif": 14319,
	"./GfT0274.1.tif": 99542,
	"./GfT0275.1.tif": 45723,
	"./GfT0276.1.tif": 38328,
	"./GfT0280.1.tif": 48159,
	"./GfT0280.2.tif": 69824,
	"./GfT0282.1.tif": 67201,
	"./GfT0282.2.tif": 8254,
	"./GfT0283.1.tif": 15244,
	"./GfT0284.1.tif": 53595,
	"./GfT0285.1.tif": 86198,
	"./GfT0291.1.tif": 93137,
	"./GfT0292.1.tif": 75882,
	"./GfT0294.1.tif": 79688,
	"./GfT0295.1.tif": 38349,
	"./GfT0296.1.tif": 34310,
	"./GfT0297.1.tif": 64139,
	"./GfT0298.1.tif": 51876,
	"./GfT0300.1.tif": 75178,
	"./GfT0301.1.tif": 36719,
	"./GfT0302.1.tif": 30300,
	"./GfT0303.1.tif": 24689,
	"./GfT0304.1.tif": 51142,
	"./GfT0305.1.tif": 59435,
	"./GfT0306.1.tif": 1608,
	"./GfT0307.1.tif": 90253,
	"./GfT0308.1.tif": 75410,
	"./GfT0309.1.tif": 66967,
	"./GfT0310.1.tif": 54997,
	"./GfT0311.1.tif": 72720,
	"./GfT0312.1.tif": 79667,
	"./GfT0313.1.tif": 53710,
	"./GfT0314.1.tif": 38425,
	"./GfT0315.1.tif": 91396,
	"./GfT0316.1.tif": 63383,
	"./GfT0317.1.tif": 4498,
	"./GfT0318.1.tif": 77869,
	"./GfT0319.1.tif": 61736,
	"./GfT0320.1.tif": 60648,
	"./GfT0321.1.tif": 19309,
	"./GfT0322.1.tif": 15270,
	"./GfT0323.1.tif": 61451,
	"./GfT0324.1.tif": 36956,
	"./GfT0325.1.tif": 74097,
	"./GfT0326.1.tif": 56842,
	"./GfT0327.1.tif": 87311,
	"./GfT0333.1.tif": 31992,
	"./GfT0333.2.tif": 47031,
	"./GfT0333.3.tif": 26406,
	"./GfT0336.1.tif": 48161,
	"./GfT0337.1.tif": 96204,
	"./GfT0345.1.tif": 12415,
	"./GfT0347.1.tif": 18753,
	"./GfT0348.1.tif": 64926,
	"./GfT0349.1.tif": 21091,
	"./GfT0351.1.tif": 21244,
	"./GfT0352.1.tif": 71599,
	"./GfT0353.1.tif": 24778,
	"./GfT0355.1.tif": 44936,
	"./GfT0356.1.tif": 29387,
	"./GfT0357.1.tif": 83206,
	"./GfT0358.1.tif": 71097,
	"./GfT0359.1.tif": 772,
	"./GfT0360.1.tif": 34228,
	"./GfT0362.1.tif": 70242,
	"./GfT0362.2.tif": 13909,
	"./GfT0364.1.tif": 8723,
	"./GfT0364.2.tif": 25791,
	"./GfT0364.3.tif": 31310,
	"./GfT0367.1.tif": 34563,
	"./GfT0368.1.tif": 27916,
	"./GfT0371.1.tif": 53202,
	"./GfT0371.2.tif": 12613,
	"./GfT0371.3.tif": 69428,
	"./GfT0372.1.tif": 22137,
	"./GfT0373.1.tif": 60644,
	"./GfT0375.1.tif": 25262,
	"./GfT0376.1.tif": 84053,
	"./GfT0376.2.tif": 91362,
	"./GfT0377.1.tif": 49136,
	"./GfT0378.1.tif": 71983,
	"./GfT0379.1.tif": 10442,
	"./GfT0381.1.tif": 57671,
	"./GfT0382.1.tif": 81556,
	"./GfT0383.1.tif": 38601,
	"./GfT0384.1.tif": 96414,
	"./GfT0386.1.tif": 31456,
	"./GfT0387.1.tif": 25157,
	"./GfT0388.1.tif": 51290,
	"./GfT0389.1.tif": 61183,
	"./GfT0390.1.tif": 5965,
	"./GfT0391.1.tif": 33672,
	"./GfT0394.1.tif": 56753,
	"./GfT0394.2.tif": 64110,
	"./GfT0394.3.tif": 27391,
	"./GfT0395.1.tif": 62364,
	"./GfT0397.1.tif": 7242,
	"./GfT0398.1.tif": 50229,
	"./GfT0400.1.tif": 63925,
	"./GfT0403.1.tif": 5134,
	"./GfT0403.2.tif": 40305,
	"./GfT0405.1.tif": 40516,
	"./GfT0414.1.tif": 27814,
	"./GfT0416.1.tif": 42568,
	"./GfT0420.1.tif": 40667,
	"./GfT0420.2.tif": 10844,
	"./GfT0420.3.tif": 1133,
	"./GfT0424.1.tif": 26399,
	"./GfT0425.1.tif": 96858,
	"./GfT0426.1.tif": 66913,
	"./GfT0427.1.tif": 24108,
	"./GfT0430.1.tif": 81480,
	"./GfT0435.1.tif": 4561,
	"./GfT0436.1.tif": 55050,
	"./GfT0438.1.tif": 44272,
	"./GfT0441.1.tif": 78108,
	"./GfT0441.3.tif": 94522,
	"./GfT0445.1.tif": 49416,
	"./GfT0445.2.tif": 62599,
	"./GfT0445.3.tif": 99286,
	"./GfT0446.1.tif": 7243,
	"./GfT0448.1.tif": 68857,
	"./GfT0454.1.tif": 67034,
	"./GfT0454.2.tif": 61869,
	"./GfT0454.3.tif": 66972,
	"./GfT0454.4.tif": 54623,
	"./GfT0454.5.tif": 76494,
	"./GfT0455.1.tif": 76927,
	"./GfT0459.1.tif": 81283,
	"./GfT0462.1.tif": 50969,
	"./GfT0462.2.tif": 56054,
	"./GfT0462.3.tif": 88743,
	"./GfT0469.1.tif": 4650,
	"./GfT0471.1.tif": 78537,
	"./GfT0472.1.tif": 42306,
	"./GfT0473.1.tif": 71239,
	"./GfT0474.1.tif": 832,
	"./GfT0479.1.tif": 98625,
	"./GfT0479.2.tif": 74302,
	"./GfT0479.3.tif": 75151,
	"./GfT0479.4.tif": 47500,
	"./GfT0482.1.tif": 89707,
	"./GfT0482.2.tif": 67980,
	"./GfT0483.1.tif": 59878,
	"./GfT0484.1.tif": 18705,
	"./GfT0485.1.tif": 32092,
	"./GfT0486.1.tif": 58767,
	"./GfT0487.1.tif": 31178,
	"./GfT0491.1.tif": 18567,
	"./GfT0491.2.tif": 80264,
	"./GfT0491.3.tif": 99193,
	"./GfT0493.1.tif": 2185,
	"./GfT0493.2.tif": 97158,
	"./GfT0494.1.tif": 41598,
	"./GfT0497.1.tif": 14533,
	"./GfT0497.2.tif": 20498,
	"./GfT0498.1.tif": 12570,
	"./GfT0499.1.tif": 58463,
	"./GfT0501.1.tif": 39549,
	"./GfT0502.1.tif": 64438,
	"./GfT0504.1.tif": 1727,
	"./GfT0506.1.tif": 40186,
	"./GfT0507.1.tif": 3103,
	"./GfT0508.1.tif": 43648,
	"./GfT0510.1.tif": 30539,
	"./GfT0511.1.tif": 5894,
	"./GfT0512.1.tif": 52333,
	"./GfT0514.1.tif": 68175,
	"./GfT0515.1.tif": 6634,
	"./GfT0516.1.tif": 98673,
	"./GfT0518.1.tif": 69203,
	"./GfT0520.1.tif": 2362,
	"./GfT0521.1.tif": 24959,
	"./GfT0526.1.tif": 15480,
	"./GfT0529.1.tif": 3911,
	"./GfT0531.1.tif": 78912,
	"./GfT0533.1.tif": 43870,
	"./GfT0538.1.tif": 40637,
	"./GfT0539.1.tif": 95160,
	"./GfT0540.1.tif": 46020,
	"./GfT0541.1.tif": 84217,
	"./GfT0542.1.tif": 38578,
	"./GfT0543.1.tif": 30135,
	"./GfT0544.1.tif": 27568,
	"./GfT0545.1.tif": 81333,
	"./GfT0546.1.tif": 53166,
	"./GfT0547.1.tif": 30643,
	"./GfT0548.1.tif": 93468,
	"./GfT0549.1.tif": 87857,
	"./GfT0550.1.tif": 69799,
	"./GfT0551.1.tif": 33538,
	"./GfT0552.1.tif": 53417,
	"./GfT0553.1.tif": 8532,
	"./GfT0554.1.tif": 95075,
	"./GfT0555.1.tif": 92830,
	"./GfT0556.1.tif": 82117,
	"./GfT0557.1.tif": 22688,
	"./GfT0558.1.tif": 9695,
	"./GfT0559.1.tif": 80154,
	"./GfT0560.1.tif": 11110,
	"./GfT0561.1.tif": 57291,
	"./GfT0562.1.tif": 25864,
	"./GfT0563.1.tif": 58349,
	"./GfT0564.1.tif": 98762,
	"./GfT0565.1.tif": 26351,
	"./GfT0576.1.tif": 99771,
	"./GfT0577.1.tif": 48726,
	"./GfT0582.1.tif": 81966,
	"./GfT0582.2.tif": 92017,
	"./GfT0582.3.tif": 39232,
	"./GfT0583.1.tif": 7923,
	"./GfT0584.1.tif": 19652,
	"./GfT0586.1.tif": 32754,
	"./GfT0587.1.tif": 91639,
	"./GfT0588.1.tif": 89992,
	"./GfT0591.1.tif": 98142,
	"./GfT0594.1.tif": 5479,
	"./GfT0595.1.tif": 14850,
	"./GfT0597.1.tif": 78836,
	"./GfT0598.1.tif": 63899,
	"./GfT0603.1.tif": 62784,
	"./GfT0603.2.tif": 88095,
	"./GfT0603.3.tif": 5518,
	"./GfT0604.1.tif": 5351,
	"./GfT0605.1.tif": 72194,
	"./GfT0608.1.tif": 97947,
	"./GfT0610.1.tif": 35024,
	"./GfT0611.1.tif": 40597,
	"./GfT0612.1.tif": 39310,
	"./GfT0615.1.tif": 66553,
	"./GfT0618.1.tif": 24040,
	"./GfT0621.1.tif": 4888,
	"./GfT0622.1.tif": 24187,
	"./GfT0623.1.tif": 78006,
	"./GfT0624.1.tif": 50433,
	"./GfT0628.1.tif": 82341,
	"./GfT0629.1.tif": 22912,
	"./GfT0630.1.tif": 38802,
	"./GfT0631.1.tif": 30359,
	"./GfT0632.1.tif": 46244,
	"./GfT0633.1.tif": 84441,
	"./GfT0634.1.tif": 53390,
	"./GfT0642.1.tif": 20929,
	"./GfT0643.1.tif": 92268,
	"./GfT0644.1.tif": 99995,
	"./GfT0647.1.tif": 54904,
	"./GfT0649.1.tif": 50946,
	"./GfT0650.1.tif": 83548,
	"./GfT0652.1.tif": 98986,
	"./GfT0654.1.tif": 26088,
	"./GfT0655.1.tif": 58573,
	"./GfT0656.1.tif": 11334,
	"./GfT0657.1.tif": 57515,
	"./GfT0658.1.tif": 55748,
	"./GfT0660.1.tif": 34489,
	"./GfT0661.1.tif": 64164,
	"./GfT0665.1.tif": 2960,
	"./GfT0665.2.tif": 36751,
	"./GfT0665.3.tif": 39454,
	"./GfT0666.1.tif": 75731,
	"./GfT0672.1.tif": 84352,
	"./GfT0693.1.tif": 65883,
	"./GfT0697.1.tif": 76799,
	"./GfT0697.2.tif": 82112,
	"./GfT0698.1.tif": 47072,
	"./GfT0700.1.tif": 57862,
	"./GfT0704.1.tif": 58602,
	"./GfT0704.2.tif": 66781,
	"./GfT0704.3.tif": 91820,
	"./GfT0705.1.tif": 20143,
	"./GfT0706.1.tif": 56252,
	"./GfT0708.1.tif": 73422,
	"./GfT0710.1.tif": 83265,
	"./GfT0713.1.tif": 70682,
	"./GfT0714.1.tif": 23645,
	"./GfT0715.1.tif": 83800,
	"./GfT0716.1.tif": 91195,
	"./GfT0718.1.tif": 63177,
	"./GfT0721.1.tif": 2937,
	"./GfT0722.1.tif": 52658,
	"./GfT0723.1.tif": 27895,
	"./GfT0728.1.tif": 67356,
	"./GfT0728.2.tif": 97179,
	"./GfT0728.3.tif": 75322,
	"./GfT0728.4.tif": 84369,
	"./GfT0734.1.tif": 82723,
	"./GfT0734.2.tif": 35972,
	"./GfT0734.3.tif": 99445,
	"./GfT0734.4.tif": 84982,
	"./GfT0741.1.tif": 93631,
	"./GfT0741.2.tif": 98944,
	"./GfT0741.3.tif": 11601,
	"./GfT0741.4.tif": 13946,
	"./GfT0741.5.tif": 96155,
	"./GfT0742.1.tif": 60716,
	"./GfT0744.1.tif": 31670,
	"./GfT0744.3.tif": 51176,
	"./GfT0745.1.tif": 99067,
	"./GfT0748.1.tif": 56962,
	"./GfT0749.1.tif": 90119,
	"./GfT0750.1.tif": 66149,
	"./GfT0751.1.tif": 6720,
	"./GfT0752.1.tif": 79107,
	"./GfT0753.1.tif": 93214,
	"./GfT0754.1.tif": 37449,
	"./GfT0755.1.tif": 92564,
	"./GfT0756.1.tif": 53831,
	"./GfT0757.1.tif": 17570,
	"./GfT0758.1.tif": 64125,
	"./GfT0759.1.tif": 5048,
	"./GfT0760.1.tif": 99512,
	"./GfT0761.1.tif": 55709,
	"./GfT0762.1.tif": 77078,
	"./GfT0763.1.tif": 23259,
	"./GfT0763.2.tif": 28636,
	"./GfT0765.1.tif": 15329,
	"./GfT0769.1.tif": 30885,
	"./GfT0770.1.tif": 9611,
	"./GfT0772.1.tif": 83821,
	"./GfT0777.1.tif": 1468,
	"./GfT0792.1.tif": 36375,
	"./GfT0792.2.tif": 92984,
	"./GfT0792.3.tif": 23049,
	"./GfT0792.4.tif": 12274,
	"./GfT0806.1.tif": 46875,
	"./GfT0806.2.tif": 48252,
	"./GfT0808.1.tif": 18857,
	"./GfT0810.1.tif": 27590,
	"./GfT0811.1.tif": 57419,
	"./GfT0814.1.tif": 52810,
	"./GfT0820.1.tif": 35751,
	"./GfT0821.1.tif": 6818,
	"./GfT0821.3.tif": 59332,
	"./GfT0823.1.tif": 8660,
	"./GfT0824.1.tif": 49123,
	"./GfT0827.1.tif": 65344,
	"./GfT0830.1.tif": 88676,
	"./GfT0831.1.tif": 50169,
	"./GfT0831.2.tif": 37462,
	"./GfT0833.1.tif": 84183,
	"./GfT0842.1.tif": 62595,
	"./GfT0842.2.tif": 15844,
	"./GfT0842.3.tif": 79317,
	"./GfT0842.4.tif": 48502,
	"./GfT0847.1.tif": 14626,
	"./GfT0847.2.tif": 41941,
	"./GfT0847.3.tif": 97156,
	"./GfT0847.4.tif": 39207,
	"./GfT0848.1.tif": 71389,
	"./GfT0852.1.tif": 72268,
	"./GfT0852.2.tif": 10347,
	"./GfT0854.1.tif": 58998,
	"./GfT0855.1.tif": 88827,
	"./GfT0858.1.tif": 98402,
	"./GfT0872.1.tif": 11542,
	"./GfT0883.1.tif": 66642,
	"./GfT0883.2.tif": 60677,
	"./GfT0883.3.tif": 25396,
	"./GfT0883.4.tif": 83799,
	"./GfT0889.1.tif": 81340,
	"./GfT0889.2.tif": 75963,
	"./GfT0889.3.tif": 77402,
	"./GfT0889.4.tif": 75057,
	"./GfT0889.5.tif": 78752,
	"./GfT0889.6.tif": 73439,
	"./GfT0891.1.tif": 81187,
	"./GfT0891.2.tif": 82852,
	"./GfT0891.3.tif": 27637,
	"./GfT0897.1.tif": 58761,
	"./GfT0897.2.tif": 93382,
	"./GfT0897.3.tif": 71479,
	"./GfT0897.4.tif": 34036,
	"./GfT0897.5.tif": 77221,
	"./GfT0898.1.tif": 56950,
	"./GfT0902.1.tif": 95413,
	"./GfT0902.2.tif": 61461,
	"./GfT0902.3.tif": 69700,
	"./GfT0903.1.tif": 50951,
	"./GfT0904.1.tif": 24736,
	"./GfT0905.1.tif": 18437,
	"./GfT0908.1.tif": 5196,
	"./GfT0908.2.tif": 43275,
	"./GfT0910.1.tif": 75959,
	"./GfT0911.1.tif": 754,
	"./GfT0911.2.tif": 55717,
	"./GfT0919.1.tif": 84170,
	"./GfT0921.1.tif": 69787,
	"./GfT0922.1.tif": 66840,
	"./GfT0925.1.tif": 55519,
	"./GfT0926.1.tif": 53228,
	"./GfT0930.1.tif": 32113,
	"./GfT0931.1.tif": 29148,
	"./GfT0932.1.tif": 72175,
	"./GfT0935.1.tif": 88040,
	"./GfT0935.2.tif": 26343,
	"./GfT0935.3.tif": 94262,
	"./GfT0937.1.tif": 73286,
	"./GfT0940.1.tif": 20104,
	"./GfT0941.1.tif": 36237,
	"./GfT0942.1.tif": 5350,
	"./GfT0943.1.tif": 35179,
	"./GfT0946.1.tif": 76650,
	"./GfT0947.1.tif": 4239,
	"./GfT0950.1.tif": 77659,
	"./GfT0951.1.tif": 26614,
	"./GfT0959.1.tif": 11902,
	"./GfT0971.1.tif": 96976,
	"./GfT0971.2.tif": 30767,
	"./GfT0975.1.tif": 58180,
	"./GfT0976.1.tif": 83191,
	"./GfT0977.1.tif": 47602,
	"./GfT0981.1.tif": 9185,
	"./GfT0981.2.tif": 84862,
	"./GfT0981.3.tif": 85711,
	"./GfT0982.1.tif": 80250,
	"./GfT0991.1.tif": 15210,
	"./GfT0991.2.tif": 24829,
	"./GfT0991.3.tif": 36076,
	"./GfT0991.4.tif": 80079,
	"./GfT0992.1.tif": 32465,
	"./GfT0994.1.tif": 3467,
	"./GfT0994.2.tif": 65388,
	"./GfT0997.1.tif": 19016,
	"./GfT0998.1.tif": 32567,
	"./GfT1002.1.tif": 91608,
	"./GfT1002.2.tif": 53623,
	"./GfT1002.3.tif": 75526,
	"./GfT1002.4.tif": 59365,
	"./GfT1002.5.tif": 16180,
	"./GfT1005.1.tif": 7967,
	"./GfT1005.2.tif": 29632,
	"./GfT1005.3.tif": 37329,
	"./GfT1005.4.tif": 28282,
	"./GfT1006.1.tif": 28972,
	"./GfT1008.1.tif": 70942,
	"./GfT1010.1.tif": 3537,
	"./GfT1014.1.tif": 57197,
	"./GfT1014.2.tif": 74874,
	"./GfT1015.1.tif": 37928,
	"./GfT1016.1.tif": 35403,
	"./GfT1018.1.tif": 23193,
	"./GfT1021.1.tif": 90345,
	"./GfT1022.1.tif": 70466,
	"./GfT1023.1.tif": 6727,
	"./GfT1025.1.tif": 19045,
	"./GfT1026.1.tif": 29758,
	"./GfT1027.1.tif": 15651,
	"./GfT1029.1.tif": 87137,
	"./GfT1034.1.tif": 80723,
	"./GfT1036.1.tif": 56053,
	"./GfT1043.1.tif": 91505,
	"./GfT1047.1.tif": 36717,
	"./GfT1047.2.tif": 41882,
	"./GfT1047.3.tif": 16763,
	"./GfT1049.1.tif": 75255,
	"./GfT1050.1.tif": 18261,
	"./GfT1067.1.tif": 5103,
	"./GfT1068.1.tif": 98608,
	"./GfT1072.1.tif": 8605,
	"./GfT1073.1.tif": 52408,
	"./GfT1076.1.tif": 51873,
	"./GfT1077.1.tif": 12620,
	"./GfT1078.1.tif": 54211,
	"./GfT1079.1.tif": 98046,
	"./GfT1082.1.tif": 5840,
	"./GfT1085.1.tif": 96503,
	"./GfT1086.1.tif": 24516,
	"./GfT1087.1.tif": 71545,
	"./GfT1088.1.tif": 80102,
	"./GfT1089.1.tif": 26283,
	"./GfT1090.1.tif": 48073,
	"./GfT1093.1.tif": 19714,
	"./GfT1094.1.tif": 27301,
	"./GfT1095.1.tif": 80576,
	"./GfT1100.1.tif": 42003,
	"./GfT1101.1.tif": 89870,
	"./GfT1101.2.tif": 46001,
	"./GfT1101.3.tif": 89664,
	"./GfT1102.1.tif": 91157,
	"./GfT1103.1.tif": 85584,
	"./GfT1105.1.tif": 13829,
	"./GfT1108.1.tif": 59051,
	"./GfT1108.2.tif": 20972,
	"./GfT1109.1.tif": 12870,
	"./GfT1111.1.tif": 80325,
	"./GfT1113.1.tif": 50755,
	"./GfT1114.1.tif": 10292,
	"./GfT1115.1.tif": 28329,
	"./GfT1117.1.tif": 37383,
	"./GfT1117.2.tif": 80232,
	"./GfT1118.1.tif": 48952,
	"./GfT1118.2.tif": 8695,
	"./GfT1119.1.tif": 5149,
	"./GfT1120.1.tif": 87853,
	"./GfT1121.1.tif": 15560,
	"./GfT1123.1.tif": 48742,
	"./GfT1123.2.tif": 65097,
	"./GfT1124.1.tif": 38641,
	"./GfT1126.1.tif": 34319,
	"./GfT1127.1.tif": 72778,
	"./GfT1128.1.tif": 15765,
	"./GfT1131.1.tif": 39559,
	"./GfT1131.2.tif": 26376,
	"./GfT1131.3.tif": 5337,
	"./GfT1132.1.tif": 47092,
	"./GfT1133.1.tif": 20489,
	"./GfT1133.2.tif": 4134,
	"./GfT1134.1.tif": 78302,
	"./GfT1136.1.tif": 13344,
	"./GfT1136.2.tif": 38655,
	"./GfT1137.1.tif": 7045,
	"./GfT1143.1.tif": 17756,
	"./GfT1147.1.tif": 76648,
	"./GfT1151.1.tif": 993,
	"./GfT1154.1.tif": 55448,
	"./GfT1154.2.tif": 87447,
	"./GfT1154.3.tif": 88390,
	"./GfT1154.4.tif": 64325,
	"./GfT1154.5.tif": 29044,
	"./GfT1155.1.tif": 14525,
	"./GfT1156.1.tif": 28566,
	"./GfT1157.1.tif": 58395,
	"./GfT1157.2.tif": 44924,
	"./GfT1158.1.tif": 42964,
	"./GfT1159.1.tif": 4201,
	"./GfT1160.1.tif": 12617,
	"./GfT1161.1.tif": 78228,
	"./GfT1162.1.tif": 5319,
	"./GfT1163.1.tif": 76386,
	"./GfT1164.1.tif": 48261,
	"./GfT1165.1.tif": 34912,
	"./GfT1167.1.tif": 78878,
	"./GfT1168.1.tif": 32705,
	"./GfT1169.1.tif": 77100,
	"./GfT1170.1.tif": 22862,
	"./GfT1173.1.tif": 98005,
	"./GfT1174.1.tif": 50802,
	"./GfT1176.1.tif": 58244,
	"./GfT1176.2.tif": 21347,
	"./GfT1176.3.tif": 86498,
	"./GfT1177.1.tif": 19737,
	"./GfT1177.2.tif": 7030,
	"./GfT1178.1.tif": 7302,
	"./GfT1179.1.tif": 31947,
	"./GfT1180.1.tif": 16443,
	"./GfT1180.2.tif": 17820,
	"./GfT1180.3.tif": 12717,
	"./GfT1181.1.tif": 49046,
	"./GfT1182.1.tif": 43005,
	"./GfT1183.1.tif": 13880,
	"./GfT1184.1.tif": 11007,
	"./GfT1187.1.tif": 78092,
	"./GfT1187.2.tif": 16171,
	"./GfT1187.3.tif": 83402,
	"./GfT1187.4.tif": 29217,
	"./GfT1191.1.tif": 1197,
	"./GfT1192.1.tif": 74777,
	"./GfT1192.2.tif": 85833,
	"./GfT1193.1.tif": 26987,
	"./GfT1194.1.tif": 18844,
	"./GfT1195.1.tif": 55985,
	"./GfT1196.1.tif": 38730,
	"./GfT1197.1.tif": 69199,
	"./GfT1198.1.tif": 53520,
	"./GfT1200.1.tif": 8488,
	"./GfT1202.1.tif": 93734,
	"./GfT1202.2.tif": 59113,
	"./GfT1203.1.tif": 23563,
	"./GfT1205.1.tif": 52561,
	"./GfT1209.1.tif": 1749,
	"./GfT1213.1.tif": 37304,
	"./GfT1214.1.tif": 53663,
	"./GfT1215.1.tif": 74394,
	"./GfT1216.1.tif": 3329,
	"./GfT1217.1.tif": 74668,
	"./GfT1219.1.tif": 16638,
	"./GfT1220.1.tif": 40842,
	"./GfT1221.1.tif": 18735,
	"./GfT1224.1.tif": 40102,
	"./GfT1225.1.tif": 64747,
	"./GfT1227.1.tif": 2893,
	"./GfT1228.1.tif": 99954,
	"./GfT1229.1.tif": 2903,
	"./GfT1231.1.tif": 85360,
	"./GfT1232.1.tif": 41779,
	"./GfT1234.1.tif": 16889,
	"./GfT1235.1.tif": 46564,
	"./GfT1236.1.tif": 87927,
	"./GfT1237.1.tif": 35986,
	"./GfT1238.1.tif": 33037,
	"./GfT1239.1.tif": 74376,
	"./GfT1240.1.tif": 63220,
	"./GfT1241.1.tif": 20265,
	"./GfT1242.1.tif": 6178,
	"./GfT1243.1.tif": 39335,
	"./GfT1246.1.tif": 78078,
	"./GfT1246.2.tif": 67649,
	"./GfT1246.3.tif": 50640,
	"./GfT1246.4.tif": 19979,
	"./GfT1247.1.tif": 47203,
	"./GfT1258.1.tif": 50447,
	"./GfT1259.1.tif": 72554,
	"./GfT1259.2.tif": 33757,
	"./GfT1264.1.tif": 14362,
	"./GfT1264.2.tif": 96685,
	"./GfT1264.3.tif": 6396,
	"./GfT1265.1.tif": 60255,
	"./GfT1265.2.tif": 65568,
	"./GfT1266.1.tif": 57964,
	"./GfT1267.1.tif": 769,
	"./GfT1268.1.tif": 43390,
	"./GfT1268.2.tif": 67713,
	"./GfT1270.1.tif": 20497,
	"./GfT1271.1.tif": 33884,
	"./GfT1272.1.tif": 60559,
	"./GfT1273.1.tif": 49322,
	"./GfT1273.2.tif": 89565,
	"./GfT1274.1.tif": 92557,
	"./GfT1275.1.tif": 76424,
	"./GfT1276.1.tif": 7851,
	"./GfT1279.1.tif": 6084,
	"./GfT1281.1.tif": 80453,
	"./GfT1283.1.tif": 93411,
	"./GfT1284.1.tif": 6868,
	"./GfT1285.1.tif": 51753,
	"./GfT1286.1.tif": 31874,
	"./GfT1288.1.tif": 19352,
	"./GfT1291.1.tif": 32526,
	"./GfT1292.1.tif": 17461,
	"./GfT1294.1.tif": 42199,
	"./GfT1295.1.tif": 83314,
	"./GfT1297.1.tif": 70212,
	"./GfT1299.1.tif": 25798,
	"./GfT1299.2.tif": 91177,
	"./GfT1300.1.tif": 26949,
	"./GfT1301.1.tif": 63872,
	"./GfT1302.1.tif": 50979,
	"./GfT1303.1.tif": 86302,
	"./GfT1304.1.tif": 47721,
	"./GfT1305.1.tif": 66996,
	"./GfT1311.1.tif": 79295,
	"./GfT1315.1.tif": 93563,
	"./GfT1315.2.tif": 63740,
	"./GfT1315.3.tif": 54029,
	"./GfT1317.1.tif": 49693,
	"./GfT1318.1.tif": 86786,
	"./GfT1319.1.tif": 39399,
	"./GfT1320.1.tif": 92203,
	"./GfT1321.1.tif": 67558,
	"./GfT1322.1.tif": 6669,
	"./GfT1323.1.tif": 34376,
	"./GfT1325.1.tif": 91594,
	"./GfT1326.1.tif": 57457,
	"./GfT1327.1.tif": 63068,
	"./GfT1328.1.tif": 243,
	"./GfT1329.1.tif": 22766,
	"./GfT1330.1.tif": 64760,
	"./GfT1331.1.tif": 93885,
	"./GfT1332.1.tif": 99926,
	"./GfT1333.1.tif": 67323,
	"./GfT1334.1.tif": 6591,
	"./GfT1335.1.tif": 64577,
	"./GfT1336.1.tif": 51994,
	"./GfT1337.1.tif": 61887,
	"./GfT1339.1.tif": 25861,
	"./GfT1339.2.tif": 66450,
	"./GfT1341.1.tif": 96908,
	"./GfT1342.1.tif": 52204,
	"./GfT1343.1.tif": 19930,
	"./GfT1343.2.tif": 14765,
	"./GfT1344.1.tif": 61821,
	"./GfT1345.1.tif": 32696,
	"./GfT1346.1.tif": 35259,
	"./GfT1347.1.tif": 67862,
	"./GfT1348.1.tif": 7241,
	"./GfT1349.1.tif": 50196,
	"./GfT1351.1.tif": 45803,
	"./GfT1352.1.tif": 61352,
	"./GfT1353.1.tif": 20013,
	"./GfT1354.1.tif": 57546,
	"./GfT1356.1.tif": 37660,
	"./GfT1359.1.tif": 45107,
	"./GfT1359.2.tif": 55828,
	"./GfT1359.3.tif": 82661,
	"./GfT1360.1.tif": 24135,
	"./GfT1361.1.tif": 95202,
	"./GfT1362.1.tif": 31433,
	"./GfT1363.1.tif": 97044,
	"./GfT1364.1.tif": 37507,
	"./GfT1365.1.tif": 97694,
	"./GfT1366.1.tif": 67077,
	"./GfT1367.1.tif": 53728,
	"./GfT1373.1.tif": 72567,
	"./GfT1374.1.tif": 81904,
	"./GfT1375.1.tif": 16821,
	"./GfT1377.1.tif": 89427,
	"./GfT1378.1.tif": 24508,
	"./GfT1379.1.tif": 18897,
	"./GfT1381.1.tif": 6328,
	"./GfT1382.1.tif": 9275,
	"./GfT1383.1.tif": 79446,
	"./GfT1384.1.tif": 74254,
	"./GfT1385.1.tif": 92716,
	"./GfT1387.1.tif": 65466,
	"./GfT1388.1.tif": 67429,
	"./GfT1389.1.tif": 8000,
	"./GfT1390.1.tif": 23890,
	"./GfT1391.1.tif": 15447,
	"./GfT1393.1.tif": 69529,
	"./GfT1394.1.tif": 38478,
	"./GfT1395.1.tif": 32307,
	"./GfT1396.1.tif": 12880,
	"./GfT1397.1.tif": 66645,
	"./GfT1398.1.tif": 23658,
	"./GfT1399.1.tif": 85199,
	"./GfT1403.1.tif": 84705,
	"./GfT1404.1.tif": 20054,
	"./GfT1406.1.tif": 84888,
	"./GfT1406.3.tif": 79302,
	"./GfT1408.1.tif": 61698,
	"./GfT1409.1.tif": 78503,
	"./GfT1410.1.tif": 54533,
	"./GfT1418.1.tif": 52509,
	"./GfT1420.1.tif": 4248,
	"./GfT1420.2.tif": 47639,
	"./GfT1422.1.tif": 65462,
	"./GfT1424.1.tif": 48108,
	"./GfT1424.2.tif": 9483,
	"./GfT1426.1.tif": 91130,
	"./GfT1427.1.tif": 97375,
	"./GfT1432.1.tif": 72205,
	"./GfT1434.1.tif": 40207,
	"./GfT1438.1.tif": 97299,
	"./GfT1438.2.tif": 8020,
	"./GfT1438.3.tif": 34853,
	"./GfT1439.1.tif": 28814,
	"./GfT1440.1.tif": 46246,
	"./GfT1440.2.tif": 62601,
	"./GfT1440.3.tif": 32536,
	"./GfT1448.1.tif": 78158,
	"./GfT1448.2.tif": 13329,
	"./GfT1449.1.tif": 9555,
	"./GfT1456.1.tif": 79579,
	"./GfT1458.1.tif": 51561,
	"./GfT1461.1.tif": 91321,
	"./GfT1468.1.tif": 55740,
	"./GfT1469.1.tif": 58705,
	"./GfT1473.1.tif": 87124,
	"./GfT1478.1.tif": 59807,
	"./GfT1478.2.tif": 65120,
	"./GfT1478.3.tif": 89169,
	"./GfT1479.1.tif": 80538,
	"./GfT1479.2.tif": 75373,
	"./GfT1482.1.tif": 17796,
	"./GfT1482.2.tif": 16131,
	"./GfT1483.1.tif": 88121,
	"./GfT1483.2.tif": 70825,
	"./GfT1484.1.tif": 60878,
	"./GfT1484.2.tif": 17009,
	"./GfT1485.1.tif": 13011,
	"./GfT1485.2.tif": 23732,
	"./GfT1486.1.tif": 56592,
	"./GfT1486.2.tif": 90383,
	"./GfT1486.3.tif": 93086,
	"./GfT1487.1.tif": 62165,
	"./GfT1489.1.tif": 72271,
	"./GfT1491.1.tif": 16952,
	"./GfT1496.1.tif": 14079,
	"./GfT1498.1.tif": 78053,
	"./GfT1504.1.tif": 87699,
	"./GfT1505.1.tif": 10222,
	"./GfT1506.1.tif": 38389,
	"./GfT1507.1.tif": 84624,
	"./GfT1509.1.tif": 95402,
	"./GfT1514.1.tif": 35968,
	"./GfT1517.1.tif": 53699,
	"./GfT1517.2.tif": 30244,
	"./GfT1521.1.tif": 40380,
	"./GfT1522.1.tif": 83407,
	"./GfT1522.2.tif": 49616,
	"./GfT1523.1.tif": 55818,
	"./GfT1524.1.tif": 15405,
	"./GfT1525.1.tif": 99272,
	"./GfT1526.1.tif": 14347,
	"./GfT1528.1.tif": 75961,
	"./GfT1528.2.tif": 30518,
	"./GfT1529.1.tif": 28932,
	"./GfT1529.2.tif": 46499,
	"./GfT1529.3.tif": 77026,
	"./GfT1531.1.tif": 81019,
	"./GfT1531.2.tif": 67548,
	"./GfT1532.1.tif": 78072,
	"./GfT1533.1.tif": 37149,
	"./GfT1536.1.tif": 64460,
	"./GfT1536.2.tif": 2539,
	"./GfT1536.3.tif": 31242,
	"./GfT1537.1.tif": 7265,
	"./GfT1538.1.tif": 66238,
	"./GfT1539.1.tif": 52131,
	"./GfT1540.1.tif": 88891,
	"./GfT1541.1.tif": 37846,
	"./GfT1542.1.tif": 96605,
	"./GfT1545.1.tif": 97242,
	"./GfT1546.1.tif": 9825,
	"./GfT1547.1.tif": 81164,
	"./GfT1550.1.tif": 14984,
	"./GfT1553.1.tif": 46411,
	"./GfT1554.1.tif": 72444,
	"./GfT1555.1.tif": 75409,
	"./GfT1556.1.tif": 87882,
	"./GfT1557.1.tif": 15471,
	"./GfT1558.1.tif": 25968,
	"./GfT1559.1.tif": 8245,
	"./GfT1560.1.tif": 97429,
	"./GfT1561.1.tif": 91856,
	"./GfT1562.1.tif": 64627,
	"./GfT1563.1.tif": 12494,
	"./GfT1564.1.tif": 39737,
	"./GfT1566.1.tif": 94423,
	"./GfT1567.1.tif": 58834,
	"./GfT1568.1.tif": 55885,
	"./GfT1570.1.tif": 63690,
	"./GfT1571.1.tif": 25231,
	"./GfT1572.1.tif": 61340,
	"./GfT1573.1.tif": 55729,
	"./GfT1579.1.tif": 9399,
	"./GfT1580.1.tif": 56911,
	"./GfT1581.1.tif": 10090,
	"./GfT1582.1.tif": 43697,
	"./GfT1583.1.tif": 6556,
	"./GfT1585.1.tif": 68518,
	"./GfT1586.1.tif": 88909,
	"./GfT1587.1.tif": 30248,
	"./GfT1588.1.tif": 27447,
	"./GfT1589.1.tif": 91858,
	"./GfT1590.1.tif": 64812,
	"./GfT1591.1.tif": 4065,
	"./GfT1592.1.tif": 91482,
	"./GfT1593.1.tif": 97727,
	"./GfT1594.1.tif": 4600,
	"./GfT1595.1.tif": 60797,
	"./GfT1596.1.tif": 82166,
	"./GfT1597.1.tif": 11995,
	"./GfT1598.1.tif": 65940,
	"./GfT1599.1.tif": 83977,
	"./GfT1601.1.tif": 75025,
	"./GfT1602.1.tif": 41418,
	"./GfT1603.1.tif": 88239,
	"./GfT1604.1.tif": 61576,
	"./GfT1605.1.tif": 20237,
	"./GfT1606.1.tif": 16198,
	"./GfT1607.1.tif": 46027,
	"./GfT1608.1.tif": 33764,
	"./GfT1609.1.tif": 4089,
	"./GfT1610.1.tif": 30047,
	"./GfT1611.1.tif": 20154,
	"./GfT1612.1.tif": 32737,
	"./GfT1613.1.tif": 97132,
	"./GfT1614.1.tif": 35483,
	"./GfT1615.1.tif": 68086,
	"./GfT1616.1.tif": 62045,
	"./GfT1617.1.tif": 32920,
	"./GfT1618.1.tif": 26535,
	"./GfT1620.1.tif": 29630,
	"./GfT1621.1.tif": 15523,
	"./GfT1622.1.tif": 43136,
	"./GfT1623.1.tif": 2565,
	"./GfT1626.1.tif": 28980,
	"./GfT1630.1.tif": 39353,
	"./GfT1630.2.tif": 93910,
	"./GfT1633.1.tif": 89074,
	"./GfT1634.1.tif": 39573,
	"./GfT1637.1.tif": 54638,
	"./GfT1640.1.tif": 89360,
	"./GfT1641.1.tif": 71637,
	"./GfT1642.1.tif": 86702,
	"./GfT1643.1.tif": 96307,
	"./GfT1644.1.tif": 8036,
	"./GfT1645.1.tif": 71417,
	"./GfT1646.1.tif": 21138,
	"./GfT1647.1.tif": 96375,
	"./GfT1648.1.tif": 78376,
	"./GfT1649.1.tif": 10861,
	"./GfT1650.1.tif": 51203,
	"./GfT1651.1.tif": 86526,
	"./GfT1651.2.tif": 45473,
	"./GfT1652.1.tif": 27173,
	"./GfT1652.2.tif": 55858,
	"./GfT1653.1.tif": 64096,
	"./GfT1654.1.tif": 93863,
	"./GfT1655.1.tif": 3234,
	"./GfT1656.1.tif": 31593,
	"./GfT1657.1.tif": 67220,
	"./GfT1658.1.tif": 52283,
	"./GfT1659.1.tif": 1238,
	"./GfT1660.1.tif": 69842,
	"./GfT1661.1.tif": 72791,
	"./GfT1662.1.tif": 77284,
	"./GfT1663.1.tif": 38777,
	"./GfT1664.1.tif": 41902,
	"./GfT1670.1.tif": 92125,
	"./GfT1671.1.tif": 35928,
	"./GfT1671.2.tif": 95671,
	"./GfT1672.1.tif": 59675,
	"./GfT1673.1.tif": 13494,
	"./GfT1674.1.tif": 51745,
	"./GfT1675.1.tif": 96140,
	"./GfT1676.1.tif": 45407,
	"./GfT1677.1.tif": 22810,
	"./GfT1678.1.tif": 67301,
	"./GfT1679.1.tif": 53952,
	"./GfT1680.1.tif": 50756,
	"./GfT1681.1.tif": 72601,
	"./GfT1682.1.tif": 26962,
	"./GfT1683.1.tif": 18519,
	"./GfT1684.1.tif": 15952,
	"./GfT1685.1.tif": 69717,
	"./GfT1686.1.tif": 41550,
	"./GfT1687.1.tif": 35379,
	"./GfT1688.1.tif": 81852,
	"./GfT1689.1.tif": 92593,
	"./GfT1690.1.tif": 58183,
	"./GfT1691.1.tif": 21922,
	"./GfT1691.2.tif": 57141,
	"./GfT1692.1.tif": 58153,
	"./GfT1693.1.tif": 96916,
	"./GfT1694.1.tif": 83459,
	"./GfT1695.1.tif": 97566,
	"./GfT1696.1.tif": 70501,
	"./GfT1697.1.tif": 11072,
	"./GfT1698.1.tif": 98079,
	"./GfT1699.1.tif": 68538,
	"./GfT1700.1.tif": 74793,
	"./GfT1702.1.tif": 10215,
	"./GfT1702.2.tif": 97032,
	"./GfT1703.1.tif": 77058,
	"./GfT1705.1.tif": 67648,
	"./GfT1706.1.tif": 1731,
	"./GfT1707.1.tif": 48958,
	"./GfT1708.1.tif": 16417,
	"./GfT1709.1.tif": 42079,
	"./GfT1710.1.tif": 44174,
	"./GfT1711.1.tif": 12659,
	"./GfT1711.2.tif": 23380,
	"./GfT1712.1.tif": 39888,
	"./GfT1712.2.tif": 73679,
	"./GfT1713.1.tif": 45461,
	"./GfT1713.2.tif": 1794,
	"./GfT1714.1.tif": 6866,
	"./GfT1715.1.tif": 42455,
	"./GfT1716.1.tif": 1092,
	"./GfT1718.1.tif": 83526,
	"./GfT1718.2.tif": 72201,
	"./GfT1720.1.tif": 73263,
	"./GfT1720.2.tif": 5296,
	"./GfT1722.1.tif": 3761,
	"./GfT1723.1.tif": 9372,
	"./GfT1724.1.tif": 19275,
	"./GfT1724.2.tif": 74252,
	"./GfT1725.1.tif": 10982,
	"./GfT1728.1.tif": 57431,
	"./GfT1729.1.tif": 54482,
	"./GfT1730.1.tif": 29196,
	"./GfT1731.1.tif": 57857,
	"./GfT1733.1.tif": 8191,
	"./GfT1733.2.tif": 29856,
	"./GfT1734.1.tif": 91832,
	"./GfT1735.1.tif": 44637,
	"./GfT1735.2.tif": 30429,
	"./GfT1736.1.tif": 69526,
	"./GfT1737.1.tif": 36923,
	"./GfT1741.1.tif": 63016,
	"./GfT1743.1.tif": 48262,
	"./GfT1744.1.tif": 7089,
	"./GfT1745.1.tif": 20476,
	"./GfT1746.1.tif": 47151,
	"./GfT1747.1.tif": 35914,
	"./GfT1748.1.tif": 56277,
	"./GfT1749.1.tif": 74000,
	"./GfT1750.1.tif": 54338,
	"./GfT1751.1.tif": 6951,
	"./GfT1752.1.tif": 45684,
	"./GfT1754.1.tif": 29982,
	"./GfT1755.1.tif": 15875,
	"./GfT1756.1.tif": 43488,
	"./GfT1757.1.tif": 19269,
	"./GfT1758.1.tif": 17306,
	"./GfT1759.1.tif": 46847,
	"./GfT1762.1.tif": 18485,
	"./GfT1763.1.tif": 64720,
	"./GfT1764.1.tif": 67287,
	"./GfT1765.1.tif": 75730,
	"./GfT1766.1.tif": 21369,
	"./GfT1766.2.tif": 43862,
	"./GfT1767.1.tif": 83172,
	"./GfT1768.1.tif": 59755,
	"./GfT1769.1.tif": 35110,
	"./GfT1770.1.tif": 99712,
	"./GfT1771.1.tif": 93413,
	"./GfT1772.1.tif": 64670,
	"./GfT1773.1.tif": 33795,
	"./GfT1773.2.tif": 10340,
	"./GfT1774.1.tif": 49812,
	"./GfT1775.1.tif": 6857,
	"./GfT1776.1.tif": 9122,
	"./GfT1777.1.tif": 25927,
	"./GfT1777.2.tif": 29096,
	"./GfT1778.1.tif": 32312,
	"./GfT1780.1.tif": 60881,
	"./GfT1781.1.tif": 66492,
	"./GfT1781.2.tif": 65115,
	"./GfT1782.1.tif": 72911,
	"./GfT1783.1.tif": 11370,
	"./GfT1785.1.tif": 37800,
	"./GfT1786.1.tif": 11979,
	"./GfT1786.2.tif": 73900,
	"./GfT1787.1.tif": 87334,
	"./GfT1788.1.tif": 57241,
	"./GfT1789.1.tif": 19044,
	"./GfT1790.1.tif": 19702,
	"./GfT1791.1.tif": 70747,
	"./GfT1793.1.tif": 13661,
	"./GfT1794.1.tif": 71770,
	"./GfT1795.1.tif": 81663,
	"./GfT1795.2.tif": 86976,
	"./GfT1796.1.tif": 32396,
	"./GfT1797.1.tif": 84353,
	"./GfT1798.1.tif": 16894,
	"./GfT1799.1.tif": 69667,
	"./GfT1799.2.tif": 46212,
	"./GfT1800.1.tif": 6910,
	"./GfT1800.2.tif": 31233,
	"./GfT1801.1.tif": 46723,
	"./GfT1801.2.tif": 48388,
	"./GfT1802.1.tif": 62944,
	"./GfT1805.1.tif": 33351,
	"./GfT1805.2.tif": 76200,
	"./GfT1806.1.tif": 6260,
	"./GfT1807.1.tif": 40649,
	"./GfT1808.1.tif": 22486,
	"./GfT1809.1.tif": 68667,
	"./GfT1810.1.tif": 13081,
	"./GfT1811.1.tif": 42756,
	"./GfT1812.1.tif": 84119,
	"./GfT1813.1.tif": 48530,
	"./GfT1814.1.tif": 87125,
	"./GfT1815.1.tif": 81552,
	"./GfT1816.1.tif": 54323,
	"./GfT1817.1.tif": 2190,
	"./GfT1817.2.tif": 41969,
	"./GfT1818.1.tif": 84017,
	"./GfT1818.2.tif": 44238,
	"./GfT1818.3.tif": 22367,
	"./GfT1819.1.tif": 46876,
	"./GfT1820.1.tif": 62140,
	"./GfT1821.1.tif": 48753,
	"./GfT1822.1.tif": 77578,
	"./GfT1822.2.tif": 17821,
	"./GfT1823.1.tif": 88815,
	"./GfT1824.1.tif": 4680,
	"./GfT1825.1.tif": 37165,
	"./GfT1825.2.tif": 42330,
	"./GfT1826.1.tif": 89926,
	"./GfT1827.1.tif": 36107,
	"./GfT1828.1.tif": 34340,
	"./GfT1829.1.tif": 81369,
	"./GfT1830.1.tif": 49855,
	"./GfT1831.1.tif": 86938,
	"./GfT1832.1.tif": 99521,
	"./GfT1833.1.tif": 70860,
	"./GfT1834.1.tif": 78587,
	"./GfT1835.1.tif": 88809,
	"./GfT1837.1.tif": 33496,
	"./GfT1837.2.tif": 95511,
	"./GfT1838.1.tif": 20167,
	"./GfT1839.1.tif": 29538,
	"./GfT1839.2.tif": 56853,
	"./GfT1840.1.tif": 17394,
	"./GfT1841.1.tif": 8951,
	"./GfT1842.1.tif": 24836,
	"./GfT1843.1.tif": 63033,
	"./GfT1843.2.tif": 85526,
	"./GfT1844.1.tif": 31982,
	"./GfT1845.1.tif": 9459,
	"./GfT1846.1.tif": 6384,
	"./GfT1846.2.tif": 40175,
	"./GfT1848.1.tif": 17162,
	"./GfT1849.1.tif": 78703,
	"./GfT1850.1.tif": 58909,
	"./GfT1851.1.tif": 83480,
	"./GfT1851.2.tif": 15479,
	"./GfT1852.1.tif": 2779,
	"./GfT1853.1.tif": 56598,
	"./GfT1854.1.tif": 29025,
	"./GfT1856.1.tif": 88511,
	"./GfT1857.1.tif": 58970,
	"./GfT1859.1.tif": 85152,
	"./GfT1859.2.tif": 79839,
	"./GfT1860.1.tif": 13616,
	"./GfT1861.1.tif": 19189,
	"./GfT1862.1.tif": 17902,
	"./GfT1863.1.tif": 86387,
	"./GfT1864.1.tif": 74820,
	"./GfT1865.1.tif": 45145,
	"./GfT1866.1.tif": 80594,
	"./GfT1867.1.tif": 16183,
	"./GfT1868.1.tif": 2632,
	"./GfT1869.1.tif": 61293,
	"./GfT1869.2.tif": 66458,
	"./GfT1870.1.tif": 75459,
	"./GfT1871.1.tif": 6334,
	"./GfT1872.1.tif": 35077,
	"./GfT1873.1.tif": 41376,
	"./GfT1875.1.tif": 50786,
	"./GfT1875.2.tif": 78101,
	"./GfT1875.3.tif": 86340,
	"./GfT1877.1.tif": 91476,
	"./GfT1878.1.tif": 76539,
	"./GfT1878.2.tif": 77916,
	"./GfT1878.3.tif": 89165,
	"./GfT1879.1.tif": 9142,
	"./GfT1879.2.tif": 4057,
	"./GfT1881.1.tif": 39307,
	"./GfT1881.2.tif": 1228,
	"./GfT1881.3.tif": 46781,
	"./GfT1882.1.tif": 54856,
	"./GfT1883.1.tif": 13517,
	"./GfT1883.2.tif": 18682,
	"./GfT1884.1.tif": 34698,
	"./GfT1885.1.tif": 81519,
	"./GfT1886.1.tif": 31164,
	"./GfT1887.1.tif": 51953,
	"./GfT1888.1.tif": 70126,
	"./GfT1888.2.tif": 9905,
	"./GfT1889.1.tif": 22259,
	"./GfT1890.1.tif": 26017,
	"./GfT1891.1.tif": 74060,
	"./GfT1892.1.tif": 23327,
	"./GfT1893.1.tif": 13434,
	"./GfT1893.2.tif": 8269,
	"./GfT1894.1.tif": 55325,
	"./GfT1895.1.tif": 9848,
	"./GfT1896.1.tif": 12411,
	"./GfT1897.1.tif": 61366,
	"./GfT1899.1.tif": 27348,
	"./GfT1900.3.tif": 48973,
	"./GfT1901.2.tif": 19833,
	"./GfT1902.1.tif": 85757,
	"./GfT1903.1.tif": 45912,
	"./GfT1904.1.tif": 39039,
	"./GfT1904.2.tif": 13728,
	"./GfT1905.1.tif": 32794,
	"./GfT1905.2.tif": 10669,
	"./GfT1907.1.tif": 89772,
	"./GfT1908.3.tif": 94165,
	"./GfT1908.4.tif": 59350,
	"./GfT1909.1.tif": 91550,
	"./GfT1909.2.tif": 21902,
	"./GfT1912.1.tif": 19974,
	"./GfT1913.1.tif": 44619,
	"./GfT1914.1.tif": 18364,
	"./GfT1914.2.tif": 40283,
	"./GfT1915.1.tif": 29105,
	"./GfT1916.1.tif": 20714,
	"./GfT1917.1.tif": 82255,
	"./GfT1917.2.tif": 14288,
	"./GfT1918.1.tif": 75760,
	"./GfT1919.1.tif": 10677,
	"./GfT1920.1.tif": 62556,
	"./GfT1921.1.tif": 41648,
	"./GfT1922.1.tif": 61075,
	"./GfT1923.1.tif": 67246,
	"./GfT1923.2.tif": 76241,
	"./GfT1924.1.tif": 14649,
	"./GfT1925.1.tif": 76452,
	"./GfT1927.1.tif": 69010,
	"./GfT1928.1.tif": 67501,
	"./GfT1931.3.tif": 15233,
	"./GfT1931.4.tif": 69418,
	"./GfT1931.5.tif": 67563,
	"./GfT1932.1.tif": 31516,
	"./GfT1933.1.tif": 91038,
	"./GfT1934.1.tif": 9830,
	"./GfT1935.1.tif": 39659,
	"./GfT1936.1.tif": 55208,
	"./GfT1937.1.tif": 13869,
	"./GfT1939.2.tif": 53720,
	"./GfT1942.1.tif": 32985,
	"./GfT1943.1.tif": 85956,
	"./GfT1943.2.tif": 3523,
	"./GfT1944.1.tif": 57875,
	"./GfT1945.1.tif": 48270,
	"./GfT1945.2.tif": 58321,
	"./GfT1946.1.tif": 49557,
	"./GfT1947.1.tif": 67280,
	"./GfT1947.2.tif": 35247,
	"./GfT1948.1.tif": 40431,
	"./GfT1949.1.tif": 12842,
	"./GfT1950.1.tif": 22612,
	"./GfT1951.1.tif": 83849,
	"./GfT1952.1.tif": 47618,
	"./GfT1953.1.tif": 83879,
	"./GfT1954.1.tif": 36768,
	"./GfT1955.1.tif": 96197,
	"./GfT1956.1.tif": 23262,
	"./GfT1957.1.tif": 9155,
	"./GfT1957.2.tif": 91588,
	"./GfT1958.1.tif": 21484,
	"./GfT1959.1.tif": 80641,
	"./GfT1961.1.tif": 2652,
	"./GfT1962.1.tif": 66543,
	"./GfT1963.1.tif": 88650,
	"./GfT1964.1.tif": 50701,
	"./GfT1966.1.tif": 12555,
	"./GfT1967.1.tif": 87910,
	"./GfT1969.1.tif": 55204,
	"./GfT1970.1.tif": 62806,
	"./GfT1971.1.tif": 13851,
	"./GfT1973.1.tif": 21565,
	"./GfT1973.2.tif": 29738,
	"./GfT1974.1.tif": 22202,
	"./GfT1977.1.tif": 34785,
	"./GfT1978.1.tif": 64446,
	"./GfT1979.1.tif": 29123,
	"./GfT1980.1.tif": 15347,
	"./GfT1981.1.tif": 67598,
	"./GfT1982.1.tif": 42741,
	"./GfT1983.1.tif": 7824,
	"./GfT1984.1.tif": 98487,
	"./GfT1985.1.tif": 95538,
	"./GfT1986.1.tif": 64473,
	"./GfT1987.1.tif": 2980,
	"./GfT1988.1.tif": 76683,
	"./GfT1988.2.tif": 15308,
	"./GfT1990.1.tif": 89792,
	"./GfT1991.1.tif": 52869,
	"./GfT1991.2.tif": 81554,
	"./GfT1992.1.tif": 12222,
	"./GfT1993.1.tif": 76899,
	"./GfT1994.1.tif": 92916,
	"./GfT1995.1.tif": 73641,
	"./GfT1996.1.tif": 28930,
	"./GfT1997.1.tif": 19559,
	"./GfT1997.2.tif": 6376,
	"./GfT1998.1.tif": 49240,
	"./GfT1999.1.tif": 85693,
	"./GfT2000.1.tif": 51727,
	"./GfT2001.1.tif": 90186,
	"./GfT2002.1.tif": 39697,
	"./GfT2003.1.tif": 45308,
	"./GfT2003.2.tif": 43931,
	"./GfT2006.1.tif": 11290,
	"./GfT2007.1.tif": 16616,
	"./GfT2008.1.tif": 81975,
	"./GfT2009.1.tif": 90418,
	"./GfT2010.1.tif": 11212,
	"./GfT2011.1.tif": 63169,
	"./GfT2013.1.tif": 44127,
	"./GfT2014.1.tif": 47000,
	"./GfT2015.3.tif": 13067,
	"./GfT2016.1.tif": 59785,
	"./GfT2017.1.tif": 49563,
	"./GfT2017.2.tif": 50940,
	"./GfT2018.2.tif": 53779,
	"./GfT2018.3.tif": 31922,
	"./GfT2019.1.tif": 21545,
	"./GfT2020.1.tif": 29961,
	"./GfT2021.1.tif": 49236,
	"./GfT2022.1.tif": 75879,
	"./GfT2022.2.tif": 79048,
	"./GfT2023.1.tif": 85250,
	"./GfT2023.2.tif": 28917,
	"./GfT2024.1.tif": 9189,
	"./GfT2025.1.tif": 46112,
	"./GfT2026.1.tif": 49571,
	"./GfT2027.1.tif": 84894,
	"./GfT2028.1.tif": 71585,
	"./GfT2028.2.tif": 65662,
	"./GfT2029.1.tif": 42924,
	"./GfT2030.2.tif": 78769,
	"./GfT2031.1.tif": 78323,
	"./GfT2031.2.tif": 54868,
	"./GfT2035.1.tif": 78391,
	"./GfT2036.1.tif": 6404,
	"./GfT2037.1.tif": 53433,
	"./GfT2038.1.tif": 61990,
	"./GfT2039.1.tif": 91819,
	"./GfT2040.1.tif": 3731,
	"./GfT2041.1.tif": 72334,
	"./GfT2041.2.tif": 91153,
	"./GfT2041.3.tif": 94848,
	"./GfT2042.1.tif": 31125,
	"./GfT2043.1.tif": 96208,
	"./GfT2044.1.tif": 3223,
	"./GfT2044.2.tif": 43480,
	"./GfT2045.1.tif": 83922,
	"./GfT2046.1.tif": 52857,
	"./GfT2048.1.tif": 65067,
	"./GfT2049.1.tif": 40422,
	"./GfT2050.1.tif": 78176,
	"./GfT2050.2.tif": 72863,
	"./GfT2052.1.tif": 606,
	"./GfT2052.2.tif": 59553,
	"./GfT2053.1.tif": 65283,
	"./GfT2053.2.tif": 18532,
	"./GfT2054.1.tif": 81300,
	"./GfT2055.1.tif": 62025,
	"./GfT2056.1.tif": 17314,
	"./GfT2057.1.tif": 7943,
	"./GfT2058.1.tif": 37624,
	"./GfT2059.1.tif": 74077,
	"./GfT2059.2.tif": 82250,
	"./GfT2060.1.tif": 34317,
	"./GfT2060.2.tif": 39482,
	"./GfT2061.1.tif": 75656,
	"./GfT2062.1.tif": 60107,
	"./GfT2062.2.tif": 38380,
	"./GfT2063.1.tif": 30278,
	"./GfT2064.1.tif": 89105,
	"./GfT2065.1.tif": 51964,
	"./GfT2066.1.tif": 2319,
	"./GfT2066.2.tif": 61200,
	"./GfT2067.2.tif": 81469,
	"./GfT2068.1.tif": 92213,
	"./GfT2069.1.tif": 86640,
	"./GfT2070.1.tif": 9506,
	"./GfT2070.2.tif": 18549,
	"./GfT2071.1.tif": 38439,
	"./GfT2072.1.tif": 11348,
	"./GfT2072.2.tif": 5075,
	"./GfT2073.1.tif": 45737,
	"./GfT2074.1.tif": 11998,
	"./GfT2074.2.tif": 19969,
	"./GfT2075.1.tif": 51811,
	"./GfT2076.1.tif": 68032,
	"./GfT2077.1.tif": 81381,
	"./GfT2078.1.tif": 53242,
	"./GfT2079.1.tif": 59487,
	"./GfT2080.1.tif": 46327,
	"./GfT2081.1.tif": 87442,
	"./GfT2082.1.tif": 43750,
	"./GfT2083.1.tif": 74340,
	"./GfT2084.1.tif": 62611,
	"./GfT2084.2.tif": 22804,
	"./GfT2085.1.tif": 36654,
	"./GfT2086.4.tif": 96904,
	"./GfT2086.5.tif": 15833,
	"./GfT2087.1.tif": 55664,
	"./GfT2087.2.tif": 23631,
	"./GfT2088.4.tif": 93066,
	"./GfT2089.1.tif": 17578,
	"./GfT2090.1.tif": 10996,
	"./GfT2091.1.tif": 72233,
	"./GfT2092.1.tif": 36002,
	"./GfT2094.1.tif": 25152,
	"./GfT2095.1.tif": 84581,
	"./GfT2096.1.tif": 11646,
	"./GfT2097.1.tif": 97539,
	"./GfT2098.1.tif": 26220,
	"./GfT2099.1.tif": 69025,
	"./GfT2100.1.tif": 5778,
	"./GfT2101.1.tif": 97335,
	"./GfT2103.1.tif": 51417,
	"./GfT2103.2.tif": 73910,
	"./GfT2104.1.tif": 20366,
	"./GfT2104.2.tif": 13009,
	"./GfT2105.1.tif": 97843,
	"./GfT2105.2.tif": 74388,
	"./GfT2106.1.tif": 94768,
	"./GfT2107.1.tif": 48533,
	"./GfT2107.2.tif": 13314,
	"./GfT2108.1.tif": 5546,
	"./GfT2108.2.tif": 66749,
	"./GfT2109.1.tif": 67087,
	"./GfT2110.1.tif": 47293,
	"./GfT2111.1.tif": 71864,
	"./GfT2111.2.tif": 3863,
	"./GfT2112.1.tif": 91163,
	"./GfT2112.2.tif": 77692,
	"./GfT2113.1.tif": 44982,
	"./GfT2113.2.tif": 38841,
	"./GfT2113.3.tif": 19912,
	"./GfT2114.1.tif": 17409,
	"./GfT2115.1.tif": 74604,
	"./GfT2118.1.tif": 49317,
	"./GfT2119.1.tif": 89888,
	"./GfT2119.2.tif": 68223,
	"./GfT2120.2.tif": 35791,
	"./GfT2121.1.tif": 7573,
	"./GfT2122.1.tif": 22638,
	"./GfT2123.1.tif": 74771,
	"./GfT2124.1.tif": 63204,
	"./GfT2125.1.tif": 33529,
	"./GfT2125.2.tif": 38614,
	"./GfT2127.1.tif": 4567,
	"./GfT2128.1.tif": 91016,
	"./GfT2128.2.tif": 64519,
	"./GfT2129.1.tif": 66029,
	"./GfT2129.2.tif": 71194,
	"./GfT2130.1.tif": 63843,
	"./GfT2131.1.tif": 11070,
	"./GfT2131.2.tif": 641,
	"./GfT2133.1.tif": 23731,
	"./GfT2133.2.tif": 55071,
	"./GfT2134.1.tif": 72327,
	"./GfT2135.1.tif": 39170,
	"./GfT2136.1.tif": 36905,
	"./GfT2136.2.tif": 20550,
	"./GfT2137.1.tif": 79860,
	"./GfT2140.3.tif": 58800,
	"./GfT2140.4.tif": 90219,
	"./GfT2141.1.tif": 51459,
	"./GfT2141.3.tif": 97909,
	"./GfT2141.4.tif": 57065,
	"./GfT2143.1.tif": 81029,
	"./GfT2144.1.tif": 9154,
	"./GfT2145.1.tif": 38087,
	"./GfT2145.2.tif": 80936,
	"./GfT2146.1.tif": 88615,
	"./GfT2147.1.tif": 29033,
	"./GfT2148.1.tif": 27222,
	"./GfT2148.2.tif": 23577,
	"./GfT2150.4.tif": 97188,
	"./GfT2151.1.tif": 31140,
	"./GfT2152.1.tif": 72503,
	"./GfT2153.1.tif": 36914,
	"./GfT2154.1.tif": 75509,
	"./GfT2154.2.tif": 48194,
	"./GfT2155.1.tif": 69936,
	"./GfT2155.2.tif": 3727,
	"./GfT2156.1.tif": 42707,
	"./GfT2157.1.tif": 90574,
	"./GfT2157.2.tif": 30353,
	"./GfT2158.1.tif": 72401,
	"./GfT2158.2.tif": 32622,
	"./GfT2158.3.tif": 10751,
	"./GfT2159.1.tif": 51612,
	"./GfT2160.1.tif": 50524,
	"./GfT2160.2.tif": 63995,
	"./GfT2161.1.tif": 53489,
	"./GfT2161.2.tif": 43438,
	"./GfT2162.1.tif": 65962,
	"./GfT2163.1.tif": 93551,
	"./GfT2164.1.tif": 93064,
	"./GfT2165.1.tif": 25549,
	"./GfT2166.1.tif": 78310,
	"./GfT2167.1.tif": 24491,
	"./GfT2167.2.tif": 86412,
	"./GfT2168.1.tif": 39076,
	"./GfT2169.2.tif": 40662,
	"./GfT2170.1.tif": 54591,
	"./GfT2171.1.tif": 52941,
	"./GfT2172.1.tif": 87905,
	"./GfT2173.1.tif": 59244,
	"./GfT2174.1.tif": 66971,
	"./GfT2175.1.tif": 15926,
	"./GfT2175.2.tif": 45017,
	"./GfT2176.1.tif": 74685,
	"./GfT2177.1.tif": 38232,
	"./GfT2177.2.tif": 83895,
	"./GfT2178.1.tif": 8551,
	"./GfT2179.1.tif": 17922,
	"./GfT2180.1.tif": 15290,
	"./GfT2181.1.tif": 67212,
	"./GfT2182.1.tif": 42540,
	"./GfT2183.1.tif": 85345,
	"./GfT2183.2.tif": 77374,
	"./GfT2184.1.tif": 29270,
	"./GfT2185.1.tif": 59099,
	"./GfT2185.2.tif": 45628,
	"./GfT2187.1.tif": 15229,
	"./GfT2187.2.tif": 74986,
	"./GfT2188.2.tif": 3893,
	"./GfT2189.1.tif": 4935,
	"./GfT2190.1.tif": 92485,
	"./GfT2191.1.tif": 45760,
	"./GfT2191.2.tif": 24095,
	"./GfT2192.1.tif": 32867,
	"./GfT2193.1.tif": 68190,
	"./GfT2194.1.tif": 13257,
	"./GfT2195.1.tif": 48884,
	"./GfT2196.1.tif": 75527,
	"./GfT2196.2.tif": 62344,
	"./GfT2197.1.tif": 84898,
	"./GfT2197.2.tif": 12213,
	"./GfT2198.1.tif": 41661,
	"./GfT2199.1.tif": 88856,
	"./GfT2200.1.tif": 50241,
	"./GfT2201.1.tif": 94636,
	"./GfT2201.2.tif": 56011,
	"./GfT2201.3.tif": 74218,
	"./GfT2201.4.tif": 20033,
	"./GfT2201.5.tif": 45552,
	"./GfT2201.6.tif": 86671,
	"./GfT2201.7.tif": 61086,
	"./GfT2201.8.tif": 35381,
	"./GfT2202.1.tif": 43903,
	"./GfT2202.2.tif": 18592,
	"./GfT2203.1.tif": 37658,
	"./GfT2204.1.tif": 90621,
	"./GfT2205.1.tif": 50776,
	"./GfT2206.1.tif": 58171,
	"./GfT2206.2.tif": 63548,
	"./GfT2207.1.tif": 11990,
	"./GfT2208.1.tif": 30153,
	"./GfT2209.1.tif": 95764,
	"./GfT2209.2.tif": 89491,
	"./GfT2209.3.tif": 67634,
	"./GfT2209.4.tif": 78409,
	"./GfT2209.5.tif": 64696,
	"./GfT2209.6.tif": 8087,
	"./GfT2209.7.tif": 78406,
	"./GfT2209.8.tif": 65933,
	"./GfT2210.1.tif": 24838,
	"./GfT2210.10.tif": 83864,
	"./GfT2210.11.tif": 33161,
	"./GfT2210.2.tif": 41193,
	"./GfT2210.3.tif": 11128,
	"./GfT2210.4.tif": 35923,
	"./GfT2210.5.tif": 30418,
	"./GfT2210.6.tif": 90277,
	"./GfT2210.7.tif": 58548,
	"./GfT2210.8.tif": 5119,
	"./GfT2210.9.tif": 10638,
	"./GfT2212.1.tif": 68360,
	"./GfT2212.2.tif": 65191,
	"./GfT2212.3.tif": 32502,
	"./GfT2212.4.tif": 63317,
	"./GfT2212.5.tif": 23140,
	"./GfT2212.6.tif": 46595,
	"./GfT2212.7.tif": 70626,
	"./GfT2213.1.tif": 71277,
	"./GfT2214.1.tif": 25578,
	"./GfT2215.1.tif": 87119,
	"./GfT2215.2.tif": 19152,
	"./GfT2216.1.tif": 23228,
	"./GfT2217.1.tif": 33969,
	"./GfT2218.1.tif": 56750,
	"./GfT2218.2.tif": 75569,
	"./GfT2219.1.tif": 88147,
	"./GfT2220.1.tif": 92359,
	"./GfT2221.1.tif": 1730,
	"./GfT2222.1.tif": 46441,
	"./GfT2223.1.tif": 65716,
	"./GfT2225.1.tif": 85022,
	"./GfT2226.1.tif": 25669,
	"./GfT2227.1.tif": 62592,
	"./GfT2229.1.tif": 59130,
	"./GfT2231.1.tif": 69913,
	"./GfT2232.1.tif": 13605,
	"./GfT2233.4.tif": 29298,
	"./GfT2233.5.tif": 80883,
	"./GfT2234.1.tif": 87856,
	"./GfT2234.2.tif": 94556,
	"./GfT2236.2.tif": 95249,
	"./GfT2238.3.tif": 42298,
	"./GfT2238.4.tif": 67697,
	"./GfT2238.5.tif": 21267,
	"./GfT2240.1.tif": 33125,
	"./GfT2241.1.tif": 73696,
	"./GfT2243.1.tif": 60190,
	"./GfT2243.2.tif": 68161,
	"./GfT2244.2.tif": 15750,
	"./GfT2247.1.tif": 84546,
	"./GfT2248.1.tif": 31101,
	"./GfT2249.1.tif": 72024,
	"./GfT2250.1.tif": 50714,
	"./GfT2254.1.tif": 98646,
	"./GfT2255.1.tif": 66043,
	"./GfT2256.1.tif": 63480,
	"./GfT2257.1.tif": 92605,
	"./GfT2258.1.tif": 23938,
	"./GfT2260.1.tif": 76587,
	"./GfT2261.1.tif": 46758,
	"./GfT2262.1.tif": 50797,
	"./GfT2262.2.tif": 55962,
	"./GfT2263.1.tif": 92136,
	"./GfT2264.1.tif": 18799,
	"./GfT2265.1.tif": 88330,
	"./GfT2266.1.tif": 5585,
	"./GfT2267.1.tif": 68444,
	"./GfT2267.2.tif": 63067,
	"./GfT2268.2.tif": 70260,
	"./GfT2268.3.tif": 13445,
	"./GfT2268.4.tif": 98982,
	"./GfT2269.1.tif": 7406,
	"./GfT2270.1.tif": 82840,
	"./GfT2271.1.tif": 22685,
	"./GfT2272.1.tif": 44054,
	"./GfT2273.1.tif": 90235,
	"./GfT2274.1.tif": 26700,
	"./GfT2275.1.tif": 82305,
	"./GfT2276.1.tif": 53370,
	"./GfT2276.2.tif": 47597,
	"./GfT2276.3.tif": 57308,
	"./GfT2277.1.tif": 75967,
	"./GfT2277.2.tif": 50656,
	"./GfT2279.1.tif": 97861,
	"./GfT2281.3.tif": 36098,
	"./GfT2281.4.tif": 85945,
	"./GfT2282.1.tif": 3351,
	"./GfT2283.1.tif": 402,
	"./GfT2285.1.tif": 12688,
	"./GfT2285.2.tif": 53807,
	"./GfT2286.1.tif": 20211,
	"./GfT2287.1.tif": 72462,
	"./GfT2288.1.tif": 49681,
	"./GfT2288.2.tif": 14510,
	"./GfT2289.1.tif": 55292,
	"./GfT2290.1.tif": 17086,
	"./GfT2290.2.tif": 76033,
	"./GfT2291.1.tif": 81763,
	"./GfT2291.2.tif": 35012,
	"./GfT2292.2.tif": 72991,
	"./GfT2293.1.tif": 57733,
	"./GfT2294.1.tif": 33794,
	"./GfT2294.2.tif": 77461,
	"./GfT2295.1.tif": 24423,
	"./GfT2296.1.tif": 97780,
	"./GfT2296.2.tif": 21235,
	"./GfT2297.1.tif": 78505,
	"./GfT2298.1.tif": 31798,
	"./GfT2299.1.tif": 82843,
	"./GfT2299.2.tif": 60924,
	"./GfT2301.1.tif": 45513,
	"./GfT2302.1.tif": 9282,
	"./GfT2304.1.tif": 67808,
	"./GfT2305.1.tif": 97509,
	"./GfT2307.1.tif": 51587,
	"./GfT2310.1.tif": 88983,
	"./GfT2311.1.tif": 53394,
	"./GfT2312.1.tif": 17945,
	"./GfT2312.2.tif": 23030,
	"./GfT2312.3.tif": 55719,
	"./GfT2313.1.tif": 47620,
	"./GfT2314.1.tif": 59187,
	"./GfT2315.1.tif": 7054,
	"./GfT2315.2.tif": 46833,
	"./GfT2316.1.tif": 91989,
	"./GfT2317.1.tif": 86416,
	"./GfT2318.1.tif": 2095,
	"./GfT2319.1.tif": 71626,
	"./GfT2320.1.tif": 98294,
	"./GfT2321.1.tif": 49339,
	"./GfT2322.1.tif": 46776,
	"./GfT2323.1.tif": 92253,
	"./GfT2324.1.tif": 50362,
	"./GfT2325.1.tif": 66284,
	"./GfT2326.1.tif": 10988,
	"./GfT2327.1.tif": 62945,
	"./GfT2328.1.tif": 95486,
	"./GfT2329.1.tif": 48259,
	"./GfT2330.1.tif": 39473,
	"./GfT2331.1.tif": 45084,
	"./GfT2332.1.tif": 51503,
	"./GfT2335.1.tif": 16392,
	"./GfT2336.1.tif": 74219,
	"./GfT2336.2.tif": 52492,
	"./GfT2342.1.tif": 81638,
	"./GfT2343.1.tif": 6283,
	"./GfT2344.1.tif": 77148,
	"./GfT2344.2.tif": 75771,
	"./GfT2345.1.tif": 71537,
	"./GfT2347.1.tif": 83567,
	"./GfT2347.2.tif": 49776,
	"./GfT2348.1.tif": 11248,
	"./GfT2349.1.tif": 65013,
	"./GfT2350.1.tif": 7643,
	"./GfT2350.2.tif": 77820,
	"./GfT2351.1.tif": 61462,
	"./GfT2352.1.tif": 63773,
	"./GfT2352.2.tif": 7178,
	"./GfT2353.1.tif": 88344,
	"./GfT2354.1.tif": 93375,
	"./GfT2355.1.tif": 63834,
	"./GfT2356.1.tif": 33889,
	"./GfT2357.1.tif": 91084,
	"./GfT2359.1.tif": 76510,
	"./GfT2360.1.tif": 82442,
	"./GfT2361.1.tif": 10031,
	"./GfT2363.2.tif": 43566,
	"./GfT2363.3.tif": 42495,
	"./GfT2364.1.tif": 94790,
	"./GfT2365.1.tif": 40971,
	"./GfT2365.2.tif": 2892,
	"./GfT2365.3.tif": 75293,
	"./GfT2366.1.tif": 9544,
	"./GfT2367.1.tif": 42029,
	"./GfT2368.1.tif": 52306,
	"./GfT2370.1.tif": 30901,
	"./GfT2370.2.tif": 38210,
	"./GfT2370.3.tif": 14179,
	"./GfT2372.1.tif": 3507,
	"./GfT2372.2.tif": 26132,
	"./GfT2373.1.tif": 72110,
	"./GfT2374.1.tif": 68985,
	"./GfT2375.1.tif": 7492,
	"./GfT2375.2.tif": 54243,
	"./GfT2376.1.tif": 2999,
	"./GfT2377.1.tif": 50,
	"./GfT2377.2.tif": 43109,
	"./GfT2379.1.tif": 83720,
	"./GfT2379.2.tif": 96903,
	"./GfT2380.1.tif": 7788,
	"./GfT2381.1.tif": 36449,
	"./GfT2382.1.tif": 23866,
	"./GfT2383.1.tif": 86783,
	"./GfT2384.1.tif": 70424,
	"./GfT2384.2.tif": 32439,
	"./GfT2385.1.tif": 23229,
	"./GfT2386.1.tif": 48118,
	"./GfT2387.1.tif": 15515,
	"./GfT2387.2.tif": 93596,
	"./GfT2388.1.tif": 30452,
	"./GfT2389.1.tif": 94825,
	"./GfT2390.1.tif": 51855,
	"./GfT2391.1.tif": 90314,
	"./GfT2392.1.tif": 82353,
	"./GfT2393.1.tif": 87964,
	"./GfT2394.1.tif": 97867,
	"./GfT2395.1.tif": 73222,
	"./GfT2396.1.tif": 36013,
	"./GfT2397.1.tif": 16744,
	"./GfT2397.2.tif": 29927,
	"./GfT2399.1.tif": 33074,
	"./GfT2404.1.tif": 35151,
	"./GfT2405.1.tif": 73610,
	"./GfT2406.1.tif": 65649,
	"./GfT2406.2.tif": 30478,
	"./GfT2406.3.tif": 64031,
	"./GfT2409.1.tif": 88430,
	"./GfT2414.1.tif": 68703,
	"./GfT2415.1.tif": 19745,
	"./GfT2416.1.tif": 7162,
	"./GfT2417.1.tif": 86431,
	"./GfT2418.1.tif": 10624,
	"./GfT2419.1.tif": 73701,
	"./GfT2420.1.tif": 39589,
	"./GfT2420.2.tif": 80178,
	"./GfT2421.1.tif": 45888,
	"./GfT2421.2.tif": 71199,
	"./GfT2422.1.tif": 63619,
	"./GfT2423.1.tif": 10846,
	"./GfT2424.1.tif": 36681,
	"./GfT2424.2.tif": 36678,
	"./GfT2425.1.tif": 79636,
	"./GfT2426.1.tif": 72103,
	"./GfT2428.1.tif": 7613,
	"./GfT2429.1.tif": 62136,
	"./GfT2429.2.tif": 93527,
	"./GfT2430.1.tif": 69338,
	"./GfT2430.2.tif": 63565,
	"./GfT2431.1.tif": 91935,
	"./GfT2438.1.tif": 41954,
	"./GfT2438.2.tif": 34645,
	"./GfT2439.1.tif": 70887,
	"./GfT2439.2.tif": 13736,
	"./GfT2440.1.tif": 36775,
	"./GfT2441.1.tif": 514,
	"./GfT2442.1.tif": 20393,
	"./GfT2442.2.tif": 31718,
	"./GfT2443.1.tif": 75508,
	"./GfT2443.2.tif": 98963,
	"./GfT2443.3.tif": 16754,
	"./GfT2444.1.tif": 62051,
	"./GfT2444.2.tif": 44484,
	"./GfT2445.1.tif": 76158,
	"./GfT2445.2.tif": 84129,
	"./GfT2446.1.tif": 49093,
	"./GfT2446.2.tif": 55058,
	"./GfT2447.1.tif": 67283,
	"./GfT2447.2.tif": 67999,
	"./GfT2448.1.tif": 76671,
	"./GfT2448.2.tif": 98336,
	"./GfT2449.1.tif": 47130,
	"./GfT2450.1.tif": 29348,
	"./GfT2451.1.tif": 51193,
	"./GfT2452.1.tif": 5554,
	"./GfT2452.2.tif": 76869,
	"./GfT2454.1.tif": 94544,
	"./GfT2458.3.tif": 76858,
	"./GfT2460.1.tif": 87681
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75926;